import { getAudio } from './sessionHandler'

export default event => {
  const peerconnection = event.peerconnection

  peerconnection.onaddstream = ev => {
    const remoteAudio = getAudio()

    remoteAudio.srcObject = ev.stream

    remoteAudio.play()
  }

  const remoteStream = new MediaStream()

  peerconnection.getReceivers().forEach(receiver => {
    remoteStream.addTrack(receiver.track)
  })
}
